import { useCallback, useState } from 'react'

export interface DeleteModalState {
  isDeleteOpen: boolean
  openDelete: () => void
  closeDelete: () => void
}

export function useDeleteModalState(): DeleteModalState {
  const [isDeleteOpen, setIsDeleteOpen] = useState(false)

  const openDelete = useCallback(() => setIsDeleteOpen(true), [])
  const closeDelete = useCallback(() => setIsDeleteOpen(false), [])

  return { isDeleteOpen, openDelete, closeDelete }
}
